import { Star } from 'lucide-react';

const REVIEWS = [
  { text: "Awesome experience with this brokerage especially with the agent, Tom Pastor. Excellent customer service. They saved me and all my friends and relatives that I referred to them so much money on our auto, home and life insurance.", name: "Fernando S.", stars: 5 },
  { text: "Tom is absolutely wonderful to work with. He takes the time to explain everything and makes sure you're getting the right coverage for your needs. Highly professional and responsive.", name: "Maria L.", stars: 5 },
  { text: "Great experience from start to finish. They found us a much more competitive rate than what we were paying. The whole process was smooth and painless.", name: "David K.", stars: 5 }
];

export default function GoogleReviews({ compact = false }) {
  return (
    <div data-testid="google-reviews">
      {!compact && <p className="text-sm uppercase tracking-widest text-gray-400 font-medium mb-2 text-center">Real Client Feedback</p>}
      <h2 className={`${compact ? 'text-lg' : 'text-2xl md:text-3xl'} font-bold text-cwc-navy ${compact ? 'mb-4' : 'mb-3 text-center'}`}>What Our Clients Say on Google</h2>
      {!compact && <div className="flex items-center justify-center gap-1 mb-8">
        {[1,2,3,4,5].map(i => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />)}
        <span className="text-gray-500 text-sm ml-2">These clients gave us 5 stars on Google</span>
      </div>}
      <div className={`grid grid-cols-1 ${compact ? 'gap-3' : 'md:grid-cols-3 gap-5'}`}>
        {REVIEWS.map((r, i) => (
          <div key={i} className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm" data-testid={`review-${i}`}>
            <div className="flex gap-0.5 mb-3">
              {[1,2,3,4,5].map(s => <Star key={s} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />)}
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-3">"{r.text}"</p>
            <p className="text-cwc-navy font-semibold text-sm">{r.name}</p>
            <p className="text-gray-400 text-xs">Google Review</p>
          </div>
        ))}
      </div>
    </div>
  );
}
